import axiosClient from "./axiosClient";

const voucherApi = {
    getAllVouchers(params) {
        const queryString = new URLSearchParams(params).toString();
        const baseURL = `voucher${queryString ? `?${queryString}` : ""}`;
        return axiosClient.get(baseURL);
    },
    getVoucherStats() {
        const baseURL = "voucher/stats";
        return axiosClient.get(baseURL);
    },
    getVoucherById(id) {
        const baseURL = `voucher/${id}`;
        return axiosClient.get(baseURL);
    },
    createVoucher(data) {
        const baseURL = "voucher";
        return axiosClient.post(baseURL, data);
    },
    updateVoucher(id, data) {
        const baseURL = `voucher/${id}`;
        return axiosClient.put(baseURL, data);
    },
    approveVoucher(id) {
        const baseURL = `voucher/${id}/approve`;
        return axiosClient.post(baseURL);
    },
    bulkUpdateVouchers(data) {
        const baseURL = "voucher/bulk-update";
        return axiosClient.post(baseURL, data);
    },
    importVouchers(file, appOnly = false) {
        const baseURL = "voucher/import";
        const formData = new FormData();
        formData.append("file", file);
        // Đánh dấu toàn bộ voucher trong file là "chỉ đổi trên App"
        if (appOnly) formData.append("app_only", "1");
        return axiosClient.post(baseURL, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    getUserVouchers(userId) {
        const baseURL = `voucher/user/${userId}`;
        return axiosClient.get(baseURL);
    },
    bulkAssignVouchers(data) {
        const baseURL = "voucher/bulk-assign";
        return axiosClient.post(baseURL, data);
    },
    // Báo cáo đổi voucher theo tháng (khai thuế). params: { from: 'YYYY-MM', to: 'YYYY-MM' }
    getRedemptionSummary(params) {
        return axiosClient.get(`voucher/redemptions/summary?${new URLSearchParams(params)}`);
    },
    // CSV qua axios (token ở header). params thêm type: 'summary' | 'detail'
    exportRedemptions(params) {
        return axiosClient.get(`voucher/redemptions/export?${new URLSearchParams(params)}`, { responseType: "blob" });
    },
    getSampleCsvUrl() {
        return `${process.env.REACT_APP_API_URL}/voucher/sample`;
    },
};

export default voucherApi;

